import {GqlModel, GqlModelOperator, GqlQueryModel} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {JSONModel, jsonProperty} from "../json.model";

export class DealCountDataModel extends JSONModel {
  @jsonProperty("number0") total: number;
  @jsonProperty("number0") planned: number;
  @jsonProperty("number0") available: number;
  @jsonProperty("number0") ordered: number;
  @jsonProperty("number0") solutionCount: number;
  @jsonProperty("number0") disabledCount: number;
}

export class DartSolutionLocalizationCode extends JSONModel {
  @jsonProperty("string") localizationCode: string;
  @jsonProperty("string") localizationDescription: string;
}

export class DealProjectSummaryModel extends JSONModel {
  @jsonProperty("number0") totalDevices: number;
  @jsonProperty("number0") totalUsedDevices: number;
  @jsonProperty("number0") totalDisabledDevices: number;
  @jsonProperty("number0") plannedDevices: number;
  @jsonProperty("number0") orderedDevices: number;
  @jsonProperty("number0") deployedDevices: number;
  @jsonProperty("string") uniqueId: string;
  @jsonProperty("string") opportunityId: string;
  @jsonProperty("string") globalOpportunityId: string;
  @jsonProperty("string") customerBpId: string;
  @jsonProperty("string") customerName: string;
  @jsonProperty("string") resellerBpId: string;
  @jsonProperty("string") resellerName: string;
  @jsonProperty("number0") currentMaStatus: number;
}

export class DealModel extends JSONModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") dealKey: string;
  @jsonProperty("number0") projectCount: number;
  @jsonProperty("string") projectName: string;
  @jsonProperty("string") projectId: string;
  @jsonProperty("boolean") quicksilver: boolean;
  @jsonProperty(DealCountDataModel) asset: DealCountDataModel;
  @jsonProperty(DealCountDataModel) accessory: DealCountDataModel;
  @jsonProperty(DealCountDataModel) software: DealCountDataModel;
  @jsonProperty(DealCountDataModel) dis: DealCountDataModel;
  @jsonProperty([DartSolutionLocalizationCode]) salesOrg: DartSolutionLocalizationCode[];
}

export class DealListGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<DealListGqlModel> = GqlModel.buildMapper(DealListGqlModel);

  static query: any = gql`
    fragment countData on DartSolutionCount {
      total
      planned
      available
      ordered
      solutionCount
      disabledCount
    }
    
    fragment localizationCode on DartSolutionLocalizationCode {
      localizationCode
      localizationDescription
    }
    
    query getDealData($projectId: ID, $domain: String!, $includeProjects: Boolean = false) {
      deals: dealList(projectId: $projectId, domain: $domain) {
        id
        dealKey
        projectCount
        projectName
        projectId
        quicksilver

        asset {
          ...countData
        }

        accessory {
          ...countData
        }

        software {
          ...countData
        }
        dis {
          ...countData
        }
        
        salesOrg {
          ...localizationCode
        }
      }

      project: projects(id: $projectId, domain: $domain) @include(if: $includeProjects) {
        totalDevices
        totalUsedDevices
        totalDisabledDevices
        plannedDevices
        orderedDevices
        deployedDevices
        uniqueId
        opportunityId
        customerBpId
        customerName
        resellerBpId
        resellerName
        currentMaStatus
      }
    }
  `;

  @jsonProperty([DealModel]) deals: DealModel[];
  @jsonProperty(DealProjectSummaryModel, "project[0]") project: DealProjectSummaryModel;

  static variables(projectId?: string, domain?: string) {
    return {
      projectId: projectId || null,
      domain: domain || null,
      includeProjects: !!projectId,
    };
  }

  constructor(data?: any) {
    super(data || {});
  }
}
